/* eslint-disable no-return-assign */
import { CartRead, CartService, container } from '@rdss/client'
import { Build, Component, h, Prop } from '@stencil/core'
import { JSX, State } from '@stencil/core/internal'
import { store } from '~/store'

@Component({
    tag: 'zr-header',
    styleUrl: 'zr-header.scss',
    scoped: true,
})
/**
 * This component composes all header-relevant elements.
 */
export class ZrHeader {
    /**
     * The target element where to append this component.
     */
    @Prop() targetSelector = 'header > .wrapper .row--navigation .warenkorb'
    /**
     * The selector of the counter element. E.g. Counter-Badge.
     */
    @Prop() counterSelector?= 'header .cart--quantity.bubble'
    /**
     * Cart has new Item.
     */
    @State() cartHasNewItem = false
    /**
     * Trigger Element when cart overlay should be opened.
     */
    @State() cartOverLayTriggerElement: HTMLElement
    @Prop() readonly cartService = container.resolve(CartService)

    /**
     * The card data state.
     */
    @State() private cart: CartRead

    private counterElement: Element
    /**
     * Lifecycle hook, called before component is rendered.
     */
    async componentWillLoad() {
        if (Build.isServer) return

        if (this.counterSelector) {
            this.counterElement = document.querySelector(this.counterSelector)
        }

        // prevents the legacy listener
        (document.querySelector('.header__icon.header__icon--warenkorb') as HTMLElement)
            .onclick = e => e.preventDefault()

        this.cartOverLayTriggerElement = document.querySelector(this.targetSelector).parentElement as HTMLElement

        await this.loadCart()

        store.onChange('cartItemsCount', this.loadCart)
    }

    /**
     * Gets the cart data from the cart service.
     */
    private loadCart = () => this.cartService.getCart().then(({ data }) => {
        this.cart = data

        store.state.cartItemsCount = data.cartItemsCount

        if (!this.counterElement || data.cartItemsCount === 0) return

        this.counterElement.textContent = (this.cart.cartItemsCount ?? 0)?.toString()

        let bubble = this.cartOverLayTriggerElement.querySelector('.warenkorb__anzahl')

        bubble.remove()

        bubble = document.createElement('div')
        bubble.classList.add('warenkorb__anzahl', 'cart--quantity', 'bubble')
        bubble.textContent = String(data.cartItemsCount)

        this.cartOverLayTriggerElement.firstElementChild.append(bubble)
    })

    /**
     * Renders the component.
     */
    render(): JSX.Element {
        return (
            <vx-cart-overlay
                cartData={this.cart}
                snippets={this.cart?.translations}
                triggerElement={this.cartOverLayTriggerElement}>
            </vx-cart-overlay>
        )
    }
}
